import { render, staticRenderFns } from "./importSituation.vue?vue&type=template&id=ed70c2e0&scoped=true"
import script from "./importSituation.vue?vue&type=script&lang=js"
export * from "./importSituation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed70c2e0",
  null
  
)

export default component.exports